<template>
  <div>
    <v-card class="mt-4 base-card">
      <v-card-title class="d-flex justify-space-between">
        Управление справочниками
        <v-btn
          text small color="primary"
          @click="isShowTabs = !isShowTabs"
        >
          <v-icon class="uikit-icon chevron-down primary delay-03" :class="isShowTabs ? 'rotate-180': ''" />
          <span class="btn-text">{{ isShowTabs ? 'скрыть' : 'раскрыть' }}</span>
        </v-btn>
      </v-card-title>

      <v-card-text v-show="isShowTabs">
        <Tabs :tabs="tabs" />
      </v-card-text>
    </v-card>

    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Tabs from '@/components/Spm/Directories/Tabs'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Directories',
  components: { Tabs },
  metaInfo: { title: 'Справочники' },

  async created() {
    if (!this.isOperatorRoles) {
      await this.$router.push('/')
    }
  },

  data() {
    return {
      tabs: [
        { text: 'Действия', to: '/spm/directories/action' },
        { text: 'Типы событий', to: '/spm/directories/eventTypePart' }
      ],
    }
  },

  computed: {
    ...mapGetters('user', ['isOperatorRoles']),

    isShowTabs: {
      get() {
        return this.$store.getters['directoryPage/isShowTabs']
      },
      set(newValue) {
        return this.$store.commit('directoryPage/setIsShowTabs', newValue)
      },
    },
  },
}
</script>
